import React from 'react';
import PropTypes from 'prop-types';
import IconButton from "../material/IconButton";
import OverlayController from "../overlay/OverlayController";
import ActionDialog from "./ActionDialog";
import _ from 'lodash';

export default class ActionsPanel extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        delegate: PropTypes.shape({
            actionPanelDidCreateAction: PropTypes.func.isRequired,
            actionPanelDidUpdateAction: PropTypes.func.isRequired,
            actionPanelDidDeleteAction: PropTypes.func.isRequired
        }).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    onEditActionClick = (event) => {
        let actionId = event.currentTarget.dataset.actionId;
        let action = _.find(this.props.project.actions, {id: actionId});
        OverlayController.showOverlay({
            component: <ActionDialog project={this.props.project} action={action} delegate={this.props.delegate}/>
        });
    };

    onCreateActionClick = () => {
        OverlayController.showOverlay({
            component: <ActionDialog project={this.props.project} delegate={this.props.delegate}/>
        });
    };

    getIncludedStates(action) {
        if (action.itemFilter.excludeAllStates) {
            return <b>None</b>;
        }
        return this.getStateListFromStateIds(action.itemFilter.stateIdsIncluded, 'included');
    }

    getExcludedStates(action) {
        if (action.itemFilter.excludeAllStates) {
            return <b>All</b>;
        }
        return this.getStateListFromStateIds(action.itemFilter.stateIdsExcluded, 'excluded');
    }

    getStateListFromStateIds(stateIds, filterType) {
        if (!stateIds.length) {
            if (filterType === 'included') {
                return <b>Any</b>;
            } else if (filterType === 'excluded') {
                return <b>None</b>;
            }
        }
        let statesById = _.keyBy(this.props.project.states, 'id');
        let stateNames = stateIds.map(stateId => <b key={stateId}>{statesById[stateId].name}</b>);
        let result = [stateNames[0]];
        for (let i = 1; i < stateNames.length; i++) {
            result.push(', ', stateNames[i]);
        }
        return result;
    }

    renderActions() {
        let actionItems = _.map(this.props.project.actions, action => {
            let includedStates = this.getIncludedStates(action);
            let excludedStates = this.getExcludedStates(action);
            return (
                <li key={action.id} className="materialListItem threeLine">
                    <div className="materialListItemText">
                        <div className="materialListItemPrimaryText">{action.title}</div>
                        <div className="materialListItemSecondaryText truncate-ellipsis">Incl. States: {includedStates}</div>
                        <div className="materialListItemSecondaryText truncate-ellipsis">Excl. States: {excludedStates}</div>
                    </div>
                    <div className="materialListItemRightIcon">
                        <IconButton
                            buttonProps={{
                                "data-action-id": action.id
                            }}
                            icon={<i className="fa fa-sliders"/>}
                            buttonSize={IconButton.ButtonSize.buttonSize40}
                            iconFontSize={IconButton.IconFontSize.iconFontSize18}
                            onClick={this.onEditActionClick}
                        />
                    </div>
                </li>
            );
        });

        // Prepend a "create action" item
        actionItems.unshift(
            <li key="createAction" className="materialListItem singleLine" onClick={this.onCreateActionClick}>
                <div className="materialListItemText">Create Action</div>
                <div className="materialListItemRightIcon">
                    <IconButton
                        icon={<i className="fa fa-plus"/>}
                        buttonSize={IconButton.ButtonSize.buttonSize40}
                        iconFontSize={IconButton.IconFontSize.iconFontSize18}
                    />
                </div>
            </li>
        );

        return <ul className="materialList actionsPanelList">{actionItems}</ul>
    }

    render() {
        return (
            <div className="actionsPanel">
                {this.renderActions()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/diagram/ActionsPanel.js